import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";
import { TicketData } from "@/common/types/support/ticket.type";
import { formatDateTime } from "@/common/utils/formatters";
import { UserRoundIcon } from "lucide-react";

interface ClosureDataProps {
  supportTicket: TicketData
}

export default function ClosureData({supportTicket}: ClosureDataProps) {
  const formattedClosedDateTime = formatDateTime(new Date(supportTicket.closed_at))
  const closedBy = supportTicket?.closed_by

  if (!closedBy) {
    return <p className="text-sm">Resolvido no dia {formattedClosedDateTime}</p>
  }

  return (
    <div className="flex items-center gap-2">
      <p className="text-sm">Resolvido por</p>
      <ImageWithPlaceholder
        url={closedBy.profile_picture?.url}
        alt={closedBy.full_name}
        placeholderIcon={UserRoundIcon}
        className="size-8"
        iconClassName="size-6"
      />
      <p className="text-sm">{closedBy.full_name}</p>
      <p className="text-sm">no dia {formattedClosedDateTime}</p>
    </div>
  )
}
